namespace RioERP.Orders {
    export interface OrderEmailForm {
        Status: Serenity.EnumEditor;
        RowIds: Serenity.StringEditor;
    }

    export class OrderEmailForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrderEmail';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderEmailForm.init)  {
                OrderEmailForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;

                Q.initFormType(OrderEmailForm, [
                    'Status', w0,
                    'RowIds', w1
                ]);
            }
        }
    }
}
